import React, { useState } from 'react';
import { IconHelpCircle, IconChevronDown } from './SVGIcons';

const AccordionItem: React.FC<any> = ({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className='accordion-item'>
      <button
        className='accordion-trigger'
        data-open={String(open)}
        onClick={() => setOpen(!open)}
      >
        {question}
        <IconChevronDown />
      </button>
      <div
        className='accordion-content'
        style={{
          maxHeight: open ? '500px' : '0',
          padding: open ? undefined : '0',
        }}
      >
        <div className='accordion-content-inner'>{answer}</div>
      </div>
    </div>
  );
};

const CreditFaq: React.FC = () => {
  const faqs = [
    {
      q: 'What counts as an Analyzer credit?',
      a: 'Analyzer credits are consumed when you use the AI-powered actions in the ACE, AES, and Tariff Analyzers. The ACE Analyzer costs 1 credit per unique entry summary number in a run. The AES Analyzer costs 1 credit per unique shipment reference number in a run. The Tariff Analyzer costs 1 credit per 5 rows, rounded up — an 11-row file costs 3 credits. Standard features and basic screening are always unlimited.',
    },
    {
      q: 'Can I mix different plan types?',
      a: 'Absolutely. You can purchase multiple licenses across different tiers. For example, equip your core team with Standard licenses and give power users Pro or Business licenses — all managed from a single account.',
    },
    {
      q: "Why is Standard so much cheaper if it's unlimited?",
      a: 'Standard gives you unlimited access to our Tariff Checker. Pro and Business subscriptions give you access to AI-powered automation that handles complex tasks in seconds instead of hours. The credits model allows us to offer a lower entry price while giving you the flexibility to pay for advanced features when you need them.',
    },
    {
      q: 'Can I buy more credits if I run out?',
      a: "Yes. An additional one-time credit pack is available anytime from the subscription dashboard and can be adjusted depending on your team's needs.",
    },
    {
      q: 'What happens when I use all my credits?',
      a: "You'll still have full access to all Standard features. AI actions that cost analyzer credits will pause until you purchase more credits.",
    },
    {
      q: 'Can I switch plans anytime?',
      a: "Absolutely. Upgrade or downgrade at any time. When upgrading, you'll get immediate access to new features. When downgrading, changes take effect at the start of your next billing cycle.",
    },
    {
      q: 'Is there a free trial?',
      a: 'We offer a guided demo and a limited free tier so you can explore the platform before committing. Contact our team at info@bitedata.io for a personalized walkthrough.',
    },
  ];
  return (
    <div className='msp-faq'>
      <div className='msp-faq-header'>
        <div className='msp-faq-title-row'>
          <IconHelpCircle />
          <h3 className='msp-faq-title'>Frequently asked questions</h3>
        </div>
        <p className='msp-faq-subtitle'>
          Everything you need to know about our pricing
        </p>
      </div>
      <div className='msp-faq-list'>
        {faqs.map((faq, i) => (
          <AccordionItem key={i} question={faq.q} answer={faq.a} />
        ))}
      </div>
    </div>
  );
};

export default CreditFaq;
